import React, { useMemo, useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'

import Loading from '../../components/Loader/Loading'
import ArtworkCard from '../../components/Collection/ArtworkCard'

import { useActiveWeb3React } from '../../hooks'
import { getArtworksV3 } from '../../service/nft'
import { AuctionBake } from '../../constants/artwork'
import { contractAddresses } from '../../sushi/lib/constants'

const Wapper = styled.div`
  margin-top: -70px;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 0px;
    text-align: center;
  `}
`
const DropsWrapper = styled.div`
  max-width: 1050px;
  margin: 0 auto;
  position: relative;
  padding: 0px 25px 0 25px;
  text-align: center;
`
const Banner = styled.div<{bg: string}>`
  width: 100%;
  min-height: 220px;
  background-image: url(${({ bg }) => bg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  position: relative;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
  `}
`
const Mask = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 50px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding-bottom: 20px;
  `}
`
const Title = styled.div`
  font-size: 24px;
  font-family: 'Roboto-Bold';
  color: ${({ theme }) => theme.white};
  max-width: 700px;
  margin: 0 auto;
`
const Tips = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.white};
  font-family: 'Roboto-Regular';
  margin: 0 auto;
  margin-top: 15px;
  max-width: 700px;
`
// const Title2 = styled(Title)`
//   font-size: 40px;
//   color: ${({ theme }) => theme.text6};
// `
// const Tips2 = styled(Tips)`
//   color: ${({ theme }) => theme.text6};
// `
const ArtworkList = styled.div`
  display: grid;
  grid-row-gap: 20px;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fill, 459px);
  margin-top: 72px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    grid-template-columns: repeat(auto-fill, 350px);
  `}
`

const defaultList: [] = []
export default function Drops () {
  const { chainId, account } = useActiveWeb3React()
  const [artworkList, setArtworkList] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const exchangeNfts2Address = contractAddresses.exchangeNFTs2[chainId as number]

  const params = useMemo(() => {
    const ids = [
      '111-21336',
      '111-22538',
      '111-22121',
      '111-22536',
      '111-22460',
      '111-22571',
      '111-22562',
      '111-22570',
      '111-22494',
      '111-22577',
      '111-22733',
      '111-22517',
      '111-22552'
    ]
    return {
      nftType: -1,
      onSale: -3,
      offset: 0,
      limit: 100,
      ids: ids.join(','),
    }
  }, [])

  const fetchList = useCallback(async () => {
    setLoading(true)
    getArtworksV3(chainId as number, {
      ...params
    }, (err: any, data: any) => {
      setLoading(false)
      if (err) return
      if (data.code !== 0) return
      const list: any[] = data.data.list || []
      const artworks = list.map((d: any) => {
        let level = (((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake))
            || (d.price && Number(d.price))
            || ((d.auctionPrice && Number(d.auctionPrice)) && !Number(d.price) && (d.owner !== account))) &&  d.exchangeAddress?.toLowerCase() !== exchangeNfts2Address.toLowerCase() ? 'v2' : 'v3'
        return {
          ...d,
          tokenId: d.nftId || d.id,
          nftLevel: level,
          status: d.status !== undefined ? d.status : 1,
          maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
          ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
          ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
        }
      })
      setArtworkList(artworks.length > 0 ? artworks : defaultList)
    })
  }, [params, chainId, account])

  // Init List
  useEffect(() => {
    fetchList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, chainId])

  return (
    <>
      <Loading open={loading} />
      <Wapper>
        <Banner bg={'/images/drops/banner/drops_halloween.jpg'}>
          <Mask>
            <Title>
              {`Halloween NFT Event`}
            </Title>
            <Tips>
            {`
               Halloween is about the recognition of our collective dependence. This Halloween, Bakeryswap featured artists, and their friends are bringing you the scariest NFTs. 
              `}
            </Tips>
            <Tips>
              {`Bakeryswap wishes you a happy Halloween.`}
            </Tips>
          </Mask>
        </Banner>
        <DropsWrapper>
          {
            artworkList.length ?
              <ArtworkList>
                {
                  artworkList.map((d) => {
                    return (
                      <ArtworkCard key={d.id} artwork={d} width={427} height={427} padding={'16px'}></ArtworkCard>
                    )
                  })
                }
              </ArtworkList>
            : null
          }
        </DropsWrapper>
      </Wapper>
    </>
  )
}